<template>
    <div>

        <GeneralTable :isProcessing="processing" :items="items" :fields="fields" :showEyeButton="true"
            :showActionButton="false" @showItem="openCouponModal" />

        <!-- COUPON MODAL -->
        <b-modal ref="couponModal" hide-footer title="Coupon Details" size="lg">
            <div v-if="selectedCoupon" class="coupon-info">

                <div class="coupon-column">
                    <p><strong>Coupon ID:</strong> {{ selectedCoupon.id }}</p>
                    <p><strong>Name:</strong> {{ selectedCoupon.name || '—' }}</p>
                    <p><strong>Valid:</strong>
                        <span :class="selectedCoupon.valid ? 'text-success' : 'text-danger'">
                            {{ selectedCoupon.valid ? 'Yes' : 'No' }}
                        </span>
                    </p>
                    <p><strong>Duration:</strong> {{ selectedCoupon.duration }}</p>
                </div>

                <div class="coupon-column">
                    <p><strong>Discount:</strong> {{ discountLabel(selectedCoupon) }}</p>
                    <p><strong>Times Redeemed:</strong> {{ selectedCoupon.times_redeemed }}</p>
                    <p><strong>Max Redemptions:</strong>
                        {{ selectedCoupon.max_redemptions || 'Unlimited' }}
                    </p>
                    <p><strong>Created:</strong> {{ formatDate(selectedCoupon.created) }}</p>
                </div>

                <div class="coupon-column full-width" v-if="selectedCoupon.redeem_by">
                    <p><strong>Redeem By:</strong> {{ formatDate(selectedCoupon.redeem_by) }}</p>
                </div>

            </div>
        </b-modal>

    </div>
</template>
<script>
import GeneralTable from "@/components/MagicTable/GeneralTable.vue";

export default {
    name: "CoupanList",

    components: { GeneralTable },

    data() {
        return {
            processing: false,
            items: [],
            selectedCoupon: null,

            fields: [
                { key: "id", label: "Coupon Code" },
                { key: "discount", label: "Discount" },
                { key: "duration", label: "Duration" },
                { key: "times_redeemed", label: "No.of times redeemed" },
                { key: "coupon_type", label: "Coupan Type" },
                { key: "valid", label: "Valid" },
                { key: "created_at", label: "Created At" },
            ]
        };
    },

    mounted() {
        this.fetchCoupons();
    },

    methods: {
        fetchCoupons() {
            this.processing = true;

            this.$axios
                .get("subscriptions/stripe/coupons")
                .then(res => {
                    const coupons = res?.data?.data?.coupons || [];

                    this.items = coupons.map(coupon => ({
                        id: coupon.id,
                        discount: this.discountLabel(coupon),
                        duration: coupon.duration,
                        times_redeemed: coupon.times_redeemed,
                        coupon_type: coupon.amount_off ? "Fixed Price" : "Percentage",
                        valid: coupon.valid ? "Yes" : "No",
                        created_at: this.formatDate(coupon.created),
                        _raw: coupon
                    }));

                    this.processing = false;
                })
                .catch(() => {
                    this.processing = false;
                });
        },

        openCouponModal(couponId) {
            const row = this.items.find(c => c.id === couponId);
            this.selectedCoupon = row?._raw || null;
            this.$refs.couponModal.show();
        },

        discountLabel(coupon) {
            if (coupon.amount_off) {
                return `$${(coupon.amount_off / 100).toFixed(2)} off`;
            }
            if (coupon.percent_off) {
                return `${coupon.percent_off}% off`;
            }
            return '—';
        },

        formatDate(ts) {
            if (!ts) return '—';
            return new Date(ts * 1000).toLocaleString();
        }
    }
};
</script>
<style scoped>
.coupon-info {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
}

.coupon-column {
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 12px;
}

.full-width {
    grid-column: span 2;
}

@media (max-width: 768px) {
    .coupon-info {
        grid-template-columns: 1fr;
    }

    .full-width {
        grid-column: span 1;
    }
}
</style>